import CalendarMonth from "@mui/icons-material/CalendarMonth";
import Mail from "@mui/icons-material/Mail";
import { CardContent } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";
import { getInitials } from "../components/Account/utils";
import PageContainer from "../components/Common/PageContainer";
import DashboardLayout from "../components/DashboardLayout/DashboardLayout";
import InternalError from "../components/Errors/InternalError";
import Loading from "../components/Loading";
import { useUser } from "../components/Rbac/RbacQueries";

function ProfilePage() {
  const { userId } = useParams();
  const { data: user, isLoading, isError } = useUser(userId);

  const lastLogin = user?.last_login ? new Date(user.last_login) : null;

  function getContent() {
    if (isLoading) return <Loading />;
    else if (isError) return <InternalError />;
    else if (!user) return <InternalError />;
    else
      return (
        <Card>
          <CardContent>
            <Stack
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              overflow="hidden"
            >
              <Avatar className="bg-[var(--mui-palette-primary-main)] size-12 text-xl">
                {getInitials(user)}
              </Avatar>
              <Stack
                direction="column"
                justifyContent="space-evenly"
                overflow="hidden"
              >
                {user?.first_name && user?.last_name && (
                  <Typography variant="body2" fontWeight="bolder" noWrap>
                    {`${user?.first_name} ${user?.last_name}`}
                  </Typography>
                )}
                <Typography variant="caption" noWrap>
                  {user?.role}
                </Typography>
              </Stack>
            </Stack>
            <div className="mt-6">
              <h3 className="text-xl font-semibold text-gray-700">
                Informations
              </h3>
              <div className="mt-4">
                <div className="flex items-center mb-2">
                  <Mail className="text-gray-500 mr-2" />
                  <p className="text-gray-700">{user.email}</p>
                </div>
                {lastLogin && (
                  <div className="flex items-center mb-2">
                    <CalendarMonth className="text-gray-500 mr-2" />
                    <p className="text-gray-700">
                      Dernière connexion: {lastLogin.toLocaleDateString()}{" "}
                      {lastLogin.toLocaleTimeString()}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      );
  }
  return (
    <DashboardLayout>
      <PageContainer maxWidth={false} breadcrumbs={[]}>
        {getContent()}
      </PageContainer>
    </DashboardLayout>
  );
}

export default ProfilePage;
